module.exports = __webpack_public_path__ + "img/map-circle4.0dfd3aa4.svg";